import { createSelector } from 'reselect';

import { get, isEmpty } from 'lodash';
import { hpaSelector, userSelector } from '../selector';

export const selectIsHpa = createSelector([hpaSelector], (hpaSelector) => {
  return get(hpaSelector, 'isHpa');
});

export const selectHpaColor = createSelector([userSelector], (userSelector) => {
  return String(get(userSelector, 'userInfo.hetu', '')).charAt(9);
});
